import { getDb } from './index.js'
import { seedDatabase } from './seed.js'
import { adminUsers, sql } from './schema/index.js'

// Browser-compatible seed function
export async function seedBrowserDatabase() {
  try {
    // Check if we're in a Cloudflare environment
    if (typeof globalThis !== 'undefined' && 'DB' in globalThis) {
      const d1Instance = (globalThis as any).DB as D1Database
      if (d1Instance) {
        await seedDatabase(d1Instance)
        return { success: true, message: 'Database seeded successfully' }
      }
    }
    
    return { success: false, message: 'D1 database not available in browser environment' }
  } catch (error) {
    console.error('Error seeding database:', error)
    return { success: false, message: 'Failed to seed database' }
  }
}

// Function to check if database needs seeding
export async function needsSeeding(): Promise<boolean> {
  try {
    const db = getDb()
    const result = await db.select({ count: sql<number>`count(*)` }).from(adminUsers)
    return result[0]?.count === 0
  } catch (error) {
    console.error('Error checking if seeding needed:', error)
    return true
  }
}
